export default class CandidateCultureGradeQuestionDetails {
  questionPosition: number;

  questionTitle: string;

  value: string;

  comments: string;

  grade: number;

  maxGrade: number;

  constructor(obj: any) {
    this.questionPosition = obj.questionPosition;
    this.questionTitle = obj.questionTitle;
    this.value = obj.value;
    this.comments = obj.comments || '-';
    this.grade = obj.grade;
    this.maxGrade = obj.maxGrade;
  }
}
